import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddDepartmentState, addDepartmentFeatureKey } from './add-department.reducer';

const getAddDepartmentFeature = createFeatureSelector<AddDepartmentState>(addDepartmentFeatureKey);

export const getAddDepartmentCallState = createSelector(getAddDepartmentFeature, (state) => {
   return state.callState;
});
